/* ============================================================================
   hh-pdp-ux.js - product-page UX behaviour, loaded (deferred) by
   sections/hh-pdp-ux.liquid ONLY on templates that render that section.
   Split out of the section's {% javascript %} block so the .liquid file stays
   under the theme-file push ceiling. Reads per-template data from the window
   globals the section prints inline BEFORE this file (HH_USP_AFTER_BUY,
   HH_PDP_BAR); `defer` guarantees those are set before this runs.
   ============================================================================ */

/* EDIT 7 - reposition the 3 USP icons (icon-with-text). Default: directly under
   the star rating (Carpe-style trust row). On Grip-X (HH_USP_AFTER_BUY) sit them
   directly UNDER the Add to cart button instead. Guarded to only act when the
   relevant blocks exist. */
(function () {
  function move() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var usp = info.querySelector(':scope > .icon-with-text');
    if (!usp) return;
    if (window.HH_USP_AFTER_BUY) {
      var buy = null;
      Array.prototype.forEach.call(info.children, function (c) {
        if (!buy && c !== usp && c.querySelector('[name="add"], .product-form__submit')) { buy = c; }
      });
      if (buy && buy.nextElementSibling !== usp) { buy.after(usp); }
    } else {
      var rating = info.querySelector(':scope > .rating-wrapper');
      if (rating && rating.nextElementSibling !== usp) { rating.after(usp); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
  else move();
})();

/* EDIT 8 - PDP per-product volume progress bar. Driven by
   window.HH_PDP_BAR = { pid, tiers:[{q,p,bonus}] }. Builds a bar (reusing the
   cart rewards bar's .hhcr* styles) whose bubbles are THIS product's % tiers,
   and fills based on how many of its boxes are in the cart (summed across sizes
   via /cart.js). Re-reads on any cart-drawer change. Only runs where HH_PDP_BAR
   is set - Premium Blue/Black have no bar. */
(function () {
  var CFG = window.HH_PDP_BAR;
  if (!CFG || !CFG.tiers || !CFG.tiers.length) return;
  var tiers = CFG.tiers, N = tiers.length;
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S9 2 6.5 3.5 9 7 12 7ZM12 7s3-5 5.5-3.5S15 7 12 7Z"/></svg>';

  function build(el) {
    var inner = document.createElement('div');
    inner.className = 'hhcr';
    var h = '<p class="hhcr-msg" data-pb-msg></p><div class="hhcr-bar"><span class="hhcr-track"><span class="hhcr-fill" data-pb-fill style="width:0%"></span></span>';
    for (var i = 0; i < N; i++) {
      var t = tiers[i];
      var ic = t.bonus === 'ship' ? (' ' + TRUCK) : (t.bonus === 'gift' ? (' ' + GIFT) : '');
      h += '<div class="hhcr-b hhcr-d" data-pb-b="' + i + '"><span class="hhcr-pct">' + t.p + '%</span><span class="hhcr-off">OFF</span><span class="hhpb-cap">' + t.q + ' box' + (t.q > 1 ? 'es' : '') + ic + '</span></div>';
    }
    inner.innerHTML = h + '</div>';
    el.appendChild(inner);
  }

  function getHost() {
    var product = document.querySelector('.product');
    if (!product || !product.parentNode) return null;
    var el = document.querySelector('.hh-pdp-bar');
    if (!el) { el = document.createElement('div'); el.className = 'hh-pdp-bar'; product.parentNode.insertBefore(el, product); build(el); }
    return el;
  }

  function render(el, qty) {
    var last = -1, i;
    for (i = 0; i < N; i++) { if (qty >= tiers[i].q) last = i; }
    var fill;
    if (last >= N - 1) { fill = 100; }
    else {
      var prevPos = last < 0 ? 0 : last / (N - 1);
      var nextPos = (last + 1) / (N - 1);
      var prevQ = last < 0 ? 0 : tiers[last].q;
      var nextQ = tiers[last + 1].q;
      var frac = nextQ > prevQ ? (qty - prevQ) / (nextQ - prevQ) : 0;
      frac = frac < 0 ? 0 : (frac > 1 ? 1 : frac);
      fill = (prevPos + frac * (nextPos - prevPos)) * 100;
    }
    var f = el.querySelector('[data-pb-fill]'); if (f) f.style.width = fill.toFixed(1) + '%';
    for (i = 0; i < N; i++) { var b = el.querySelector('[data-pb-b="' + i + '"]'); if (b) b.classList.toggle('is-done', qty >= tiers[i].q); }
    var m = el.querySelector('[data-pb-msg]');
    if (m) {
      if (last >= N - 1) {
        m.innerHTML = '🎉 Best price unlocked — <strong>' + tiers[N - 1].p + '% off</strong>';
      } else {
        var nt = tiers[last + 1], need = nt.q - qty;
        var bonus = nt.bonus === 'ship' ? ' + <strong>free shipping</strong>' : (nt.bonus === 'gift' ? ' + a <strong>free gift</strong>' : '');
        m.innerHTML = '🔓 Add <strong>' + need + ' box' + (need > 1 ? 'es' : '') + '</strong> to unlock <strong>' + nt.p + '% off</strong>' + bonus;
      }
    }
  }

  var lastQty = -1;
  function refresh() {
    var el = getHost(); if (!el) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = 0;
        (cart.items || []).forEach(function (it) { if (String(it.product_id) === String(CFG.pid)) q += it.quantity; });
        if (q !== lastQty) { lastQty = q; render(el, q); }
      })
      .catch(function () {});
  }

  function boot() {
    var el = getHost(); if (!el) return;
    render(el, 0);
    refresh();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      var timer;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 300); })
        .observe(cd, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* EDIT 9 - shorten the middle Grip-X USP for scannability:
   "12mil thick - Toughest Grip Glove in Australia" -> "... - Toughest Glove". */
(function () {
  function fix() {
    var box = document.querySelector('.product__info-container .icon-with-text');
    if (!box) return;
    var walk = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walk.nextNode())) {
      if (/Toughest Grip Glove in Australia/i.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/Toughest Grip Glove in Australia/i, 'Toughest Glove');
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();

/* EDIT 13 - out-of-stock size alternative link. When HH_SIZE_ALT = { url, name }
   is set (Grip-X only, and only while Medium is sold out - the Liquid gates it),
   drop a small line directly under the size selector pointing to an in-stock
   alternative product. Not a .product__text block, so it is never tinted by the
   green guarantee-line rule. */
(function () {
  var A = window.HH_SIZE_ALT;
  if (!A || !A.url) return;
  function ins() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.hh-size-alt')) return;
    var vp = info.querySelector('variant-selects') || info.querySelector('.product-form__input');
    if (!vp) return;
    var d = document.createElement('div');
    d.className = 'hh-size-alt';
    d.innerHTML = 'Medium sold out? Try our <a href="' + A.url + '">' + (A.name || 'alternative') + '</a> →';
    vp.insertAdjacentElement('afterend', d);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ins);
  else ins();
})();
